export default function Flag(params) {
    const { value, innerMethods } = params;

    const booleanCell = document.createElement('div');
    booleanCell.classList.add('w5-boolean-cell');

    if (value || typeof value === 'boolean' || typeof value === 'number') {
        const svg = innerMethods?.getSvg ? innerMethods?.getSvg(value) : null;
        if (svg) {
            booleanCell.innerHTML = svg;
        } else {
            if (!value || typeof value !== 'string') {
                return booleanCell;
            } else booleanCell.innerText = value;
        }
    }

    return booleanCell;
}
